import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function activitiesTimesheet(projectId) {
    let url = 'timesheet/activities?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), project: projectId, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let activities = response.activities;

                //saveActivities(activities);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortActivity(data) {
    return data?.sort(function (a, b) {
        const nameA = IsEnglish() ? a.activityEn.toLowerCase() : a.activityFr.toLowerCase()
        const nameB = IsEnglish() ? b.activityEn.toLowerCase() : b.activityFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortActivityByCode(data) {
    return data?.sort(function (a, b) {
        const nameA = a.activity
        const nameB = b.activity
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}